import {throttle} from 'lodash';
import {useEffect, useState} from 'react';

export function useIdle(ms = 1000 * 60) {
    const [idle, setIdle] = useState(false);

    useEffect(() => {
        let timeoutId: NodeJS.Timeout;

        const handleTimeout = () => {
            setIdle(true);
        };

        const handleEvent = throttle(() => {
            setIdle(false);

            clearTimeout(timeoutId);
            timeoutId = setTimeout(handleTimeout, ms);
        }, 500);

        const handleVisibilityChange = () => {
            if (!document.hidden) {
                handleEvent();
            }
        };

        timeoutId = setTimeout(handleTimeout, ms);

        addEventListener('mousemove', handleEvent);
        addEventListener('mousedown', handleEvent);
        addEventListener('resize', handleEvent);
        addEventListener('keydown', handleEvent);
        addEventListener('touchstart', handleEvent);
        addEventListener('wheel', handleEvent);
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            removeEventListener('mousemove', handleEvent);
            removeEventListener('mousedown', handleEvent);
            removeEventListener('resize', handleEvent);
            removeEventListener('keydown', handleEvent);
            removeEventListener('touchstart', handleEvent);
            removeEventListener('wheel', handleEvent);
            document.removeEventListener(
                'visibilitychange',
                handleVisibilityChange,
            );
            clearTimeout(timeoutId);
        };
    }, [ms]);

    return idle;
}
